import "../site/site.scss";
import React, { useEffect } from "react";
import { HeaderComponent } from "../../components/header-site";
import { FooterComponent } from "../../components/footer-site";
import { FormContact } from "../../components/form-contact/FormContact";
import { LocationSection } from "../../components/location-section/LocationSection";

export default function FAQ() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <div
        id="faq"
        className="site"
        style={{ flexDirection: "column", display: "flex", flex: 1 }}
      >
        <HeaderComponent />

        <FormContact />

        <LocationSection />

        <FooterComponent />
      </div>
    </React.Fragment>
  );
}
